<script>
  import { createEventDispatcher } from "svelte";
    import DayViewCalendar from "./CalendarType/DayViewCalendar.svelte";

    export let accountId = Number(0);
    export let eventColour = "";
    export let isDoctorCalendar = false;
    export let params = {};
    export let url = "";

    const dispatch = createEventDispatcher();
</script>

<DayViewCalendar
    {accountId}
    {eventColour}
    {isDoctorCalendar}
    {params}
    {url}
    on:verticalView={() => dispatch("verticalView")}
/>
